'use client'

import * as React from 'react'

import { CreateClassProjectDialogProvider } from '../../../masterfeed/contexts/create-class-project-dialog-context'
import { SocialShareDialogProvider } from '../../contexts/social-share-dialog-context'
import { NotEnoughCoinsDialogProvider } from '../../../masterfeed/contexts/not-enough-coins-dialog-context'
import { DeleteDialogProvider } from '../../contexts/delete-dialog-context'
import { PaymentsDialogProvider } from 'payments/components/payments-dialog-wrapper-context'
import { CreateProductProjectDialogProvider } from '../../../masterfeed/contexts/create-product-project-dialog-context'
import { FollowProvider } from '../../contexts/follow-user-context'
import { JoinClubhouseModalProvider } from '@web/app/[locale]/clubhouse/[slug]/_components/join-clubhouse-modal/join-clubhouse-modal-provider'
import { ProjectDraftProvider } from '../create-post-project-dialog/project-draft-context'

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <ProjectDraftProvider>
      <SocialShareDialogProvider>
        <JoinClubhouseModalProvider>
          <CreateProductProjectDialogProvider>
            <FollowProvider>
              <CreateClassProjectDialogProvider>
                <NotEnoughCoinsDialogProvider>
                  <PaymentsDialogProvider>
                    <DeleteDialogProvider>{children}</DeleteDialogProvider>
                  </PaymentsDialogProvider>
                </NotEnoughCoinsDialogProvider>
              </CreateClassProjectDialogProvider>
            </FollowProvider>
          </CreateProductProjectDialogProvider>
        </JoinClubhouseModalProvider>
      </SocialShareDialogProvider>
    </ProjectDraftProvider>
  )
}
